import Router from "next/router";
import isRelativeUrl from "is-relative-url";
import Routes from "./../routes/routes";
import { loginUrl } from "../config/config";
import { NextPageContext } from "next";

export const RedirectChecker = async (
  signedIn: boolean,
  ctx: NextPageContext
): Promise<boolean> => {
  let { pathname, asPath, res } = ctx;

  if (signedIn) {
    if (asPath?.match(/redirect=/gi)) {
      asPath = asPath.split("redirect=")[1].replace(/\/\//g, "");
      if (!isRelativeUrl(asPath)) asPath = "/";

      if (res) {
        res.writeHead(302, { Location: asPath });
        res.end();
      } else {
        Router.push(asPath, undefined, { shallow: false });
      }

      return true;
    } else {
      if (
        Routes.unAuthenticatedRoutes.includes(pathname || "") &&
        !Routes.both.includes(pathname || "") &&
        !asPath?.match(/redirect=/gi)
      ) {
        if (res) {
          res.writeHead(302, { Location: "/" });
          res.end();
        } else {
          Router.push("/", undefined, { shallow: false });
        }
      }
      return true;
    }
  } else {
    if (pathname === "/logout") {
      if (res) {
        res.writeHead(302, { Location: "/" });
        res.end();
      } else {
        Router.push("/", undefined, { shallow: false });
      }
      return true;
    } else {
      if (
        (!Routes.unAuthenticatedRoutes.includes(pathname || "") &&
          !Routes.both.includes(pathname || "")) ||
        Routes.authenticatedRoutes.includes(pathname || "")
      ) {
        const redirectTo = `${loginUrl}/?redirect=${asPath}`;
        if (res) {
          res.writeHead(302, { Location: redirectTo });
          res.end();
        } else {
          Router.push(redirectTo, undefined, { shallow: false });
        }
        return true;
      }
    }
  }

  return false;
};

// Export both as default and named export
export default RedirectChecker;
